var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "38px",
    viewBox: "0 0 30 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1E8C2949-221D-4F57-B775-190E6D14CA3B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Welcome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P---Nueva-cita-nueva-direccion",
    transform: "translate(-188.000000, -782.000000)",
    fill: "#7D7D7D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(188.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9231732,15.5977747 L17.2103274,1.07073442 C16.6751128,0.397139037 15.868145,0.00376188937 15.0139469,2.60924448e-05 C14.1597489,-0.00365677026 13.3494736,0.382697546 12.8085643,1.0516199 L1.07682682,15.5977747 C0.380269692,16.4537623 -0.0004128896,17.5281922 3.36058653e-07,18.6369845 L3.36058653e-07,33.2213683 C0.00726527512,35.8574831 2.11753977,37.9926497 4.72292238,38 L25.2770776,38 C27.8824602,37.9926497 29.9927347,35.8574831 30.0000003,33.2213683 L30.0000003,18.6369845 C30.0004129,17.5281922 29.6197303,16.4537623 28.9231732,15.5977747 L28.9231732,15.5977747 Z M11.2216626,36.0885473 L11.2216626,25.5755576 C11.2216626,23.9920584 12.4903771,22.7083786 14.0554157,22.7083786 L15.9445843,22.7083786 C17.5096229,22.7083786 18.7783374,23.9920584 18.7783374,25.5755576 L18.7783374,36.0885473 L11.2216626,36.0885473 Z M28.110875,33.2213683 C28.0995123,34.8000997 26.8374039,36.0770955 25.2770776,36.0885473 L20.667506,36.0885473 L20.667506,25.5755576 C20.667506,22.9363922 18.552982,20.796926 15.9445843,20.796926 L14.0554157,20.796926 C11.447018,20.796926 9.33249396,22.9363922 9.33249396,25.5755576 L9.33249396,36.0885473 L4.72292238,36.0885473 C3.16259605,36.0770955 1.9004877,34.8000997 1.88912502,33.2213683 L1.88912502,18.6369845 C1.885474,17.9740845 2.11291403,17.3310942 2.53148671,16.8211044 L14.2821159,2.27494961 C14.451389,2.04608714 14.7174806,1.91164698 15,1.91164698 C15.2888031,1.90691989 15.562545,2.04185441 15.7367758,2.27494961 L27.4685133,16.8211044 C27.887086,17.3310942 28.114526,17.9740845 28.110875,18.6369845 L28.110875,33.2213683 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.a7c5bd55c73e06d8f459fe7b67eb7ac1.svg";
export { ForwardRef as ReactComponent };